import React from 'react';

const PenIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_77180_22696)">
      <path
        d="M3.33447 16.6663H6.66781L15.4178 7.91627C15.8598 7.47424 16.1082 6.87472 16.1082 6.2496C16.1082 5.62448 15.8598 5.02496 15.4178 4.58293C14.9758 4.14091 14.3763 3.89258 13.7511 3.89258C13.126 3.89258 12.5265 4.14091 12.0845 4.58293L3.33447 13.3329V16.6663Z"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 5.41602L14.5833 8.74935"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_77180_22696">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PenIcon;
